const setSearchFormURL = async () => {
  const searchForm = document.querySelector('#js-search-form');

  if (!searchForm) return false;

  searchForm.addEventListener('submit', function (e) {
    e.preventDefault();

    const input = this.querySelector('input[name="keyword"]');
    const keyword = input.value;

    // Shift_JISにエンコード
    const eucBytes = Encoding.convert(Encoding.stringToCode(keyword), 'EUCJP');
    const eucEncoded = eucBytes.map(b => '%' + b.toString(16).toUpperCase().padStart(2, '0')).join('');

    // URLを作成して遷移
    const url = `https://www.aiia-pub.com/?mode=srh&sort=n&keyword=${eucEncoded}`;
    location.href = url;
  })

  const url = encodeURI(location.href);
};

export default setSearchFormURL;